//require('dotenv').config();

import React from 'react';
import { Link } from 'react-router-dom';


import { useState, useEffect } from "react";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import "./alternatebootstrap.css";

import CommonwealthIcon from "../assets/images/cwealthicon.png"; // Adjust the path if needed

import './footer.css';

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5050";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Footer() {

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [combo, setCombo] = useState("");
  const [status, setStatus] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [refID, setRefID] = useState("");        // my ref code from server
  const [refBy, setRefBy] = useState("");    // incoming ref code from URL
  const [shareLink, setShareLink] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) setRefBy(ref.trim().toUpperCase());
  }, []);


  const postMongo = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch(`${API_BASE}/api/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email || undefined,
          phone: phone || undefined,
          combo,
          refID: refBy || undefined,
        }),
      });

      const data = await res.json();


      if (data.refID) {
        setRefID(data.refID);
        setShareLink(`${window.location.origin}/home?ref=${data.refID}`);
      }

      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }

      console.log(data.message);
      if (data.position) {
        setStatus(`${data.message} You’re #${data.position} in line.`);
      } else {
        setStatus(data.message || "Success!");
      }
      setSubmitted(true);
    } catch (err) {
      setStatus(err.message);
    }

  };

  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <footer className="footer footer--mobile">
  <div className="footer-inner">
    {/* icon */}
    <div className="footer-mobile-iconWrap">
      <img
        src={CommonwealthIcon}
        alt="Commonwealth Icon"
        className="footer-mobile-icon"
      />
    </div>

    {/* ticker */}
    <div className="ticker ticker--mobile">
      <div className="ticker__track">
        <div className="ticker__group">
          <span className="ticker__item">BUILT BEYOND BANKS</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">COMMONWEALTH</span>
          <span className="ticker__sep">•</span>
        </div>

        <div className="ticker__group" aria-hidden="true">
          <span className="ticker__item">BUILT BEYOND BANKS</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">COMMONWEALTH</span>
          <span className="ticker__sep">•</span>
        </div>

        <div className="ticker__group" aria-hidden="true">
          <span className="ticker__item">BUILT BEYOND BANKS</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
          <span className="ticker__sep">•</span>
          <span className="ticker__item">COMMONWEALTH</span>
          <span className="ticker__sep">•</span>
        </div>
      </div>
    </div>

    {/* main stacked content */}
    <div className="footer-grid footer-grid--mobile">
      {/* statement */}
      <div className="footer-statement footer-statement--mobile">
        <h2>
          Banking <br /> is dead.
        </h2>
        <p>
          Commonwealth is building financial infrastructure for the next century.
          We&apos;re rethinking how capital moves, settles, and compounds,
          starting from first principles.
        </p>
      </div>

      {/* nav */}
      <nav className="footer-nav footer-nav--mobile">
        <Link to="/home">Homepage</Link>
        <Link to="/manifesto">Mission</Link>
        <Link to="/needaj*b">Careers</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      {/* waitlist */}
      <div className={`footer-waitlist waitlist footer-waitlist--mobile ${submitted ? "success" : ""}`}>
        <h2>Join the waitlist</h2>
        <h3>Break up with your bank.</h3>

        {!submitted && (
          <>
            <div className="waitlist-toggle waitlist-toggle--mobile">
              <button
                className={combo === "emailOnly" ? "active" : ""}
                onClick={() => setCombo("emailOnly")}
                type="button"
              >
                Email
              </button>
              <button
                className={combo === "phoneOnly" ? "active" : ""}
                onClick={() => setCombo("phoneOnly")}
                type="button"
              >
                Phone
              </button>
              <button
                className={combo === "combined" ? "active" : ""}
                onClick={() => setCombo("combined")}
                type="button"
              >
                Both
              </button>
            </div>

            <form onSubmit={postMongo}>
              {combo === "emailOnly" && (
                <div className="waitlist-input waitlist-input--mobile">
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Email address"
                    required
                  />
                  <button type="submit">→</button>
                </div>
              )}

              {combo === "phoneOnly" && (
                <div className="waitlist-input waitlist-input--phone waitlist-input--mobile">
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={setPhone}
                    inputProps={{
                      name: "phone",
                      required: true,
                      autoComplete: "tel",
                    }}
                    containerClass="phone2-container"
                    inputClass="phone2-input"
                    buttonClass="phone2-flag"
                    dropdownClass="phone2-dropdown"
                    placeholder="Phone number"
                    disableSearch
                    dropdownStyle={{
                      maxHeight: "150px",
                      overflowY: "auto",
                    }}
                  />
                  <button type="submit">→</button>
                </div>
              )}

              {combo === "combined" && (
                <>
                  <div className="waitlist-input waitlist-input--mobile">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Email address"
                      required
                    />
                    <button type="submit">→</button>
                  </div>

                  <div
                    className="waitlist-input waitlist-input--phone waitlist-input--mobile"
                    style={{ marginTop: 10 }}
                  >
                    <PhoneInput
                      country={"us"}
                      value={phone}
                      onChange={setPhone}
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoComplete: "tel",
                      }}
                      containerClass="phone2-container"
                      inputClass="phone2-input"
                      buttonClass="phone2-flag"
                      dropdownClass="phone2-dropdown"
                      placeholder="Phone number"
                      disableSearch
                      dropdownStyle={{
                        maxHeight: "120px",
                        overflowY: "auto",
                      }}
                    />
                    <button type="submit">→</button>
                  </div>
                </>
              )}
            </form>
          </>
        )}

        <div className="waitlist-referral">
          <span>Your referral link</span>
          <code>{shareLink}</code>
        </div>
      </div>
    </div>

    {/* bottom */}
    <div className="footer-bottom footer-bottom--mobile">
      <span>© 2026 Commonwealth</span>

      <div className="footer-links footer-links--mobile">
        <Link to="/contact">Email</Link>
        <a href="https://x.com/trycommonwealth" target="_blank" rel="noreferrer">
          X
        </a>
        <a
          href="https://www.linkedin.com/company/commonwealthxyz"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>
      </div>
    </div>
  </div>
</footer>
    )

} else {
  return (
    <footer className="footer">

    <div className="filler-half">
      <img
        src={CommonwealthIcon}
        alt="Commonwealth Icon"
        style={{ maxWidth: "20%", maxHeight: "20%", objectFit: "contain", padding: "50px" }}
      />
    </div>

    <div className="footer-inner">
    <div className="footer-wash" />
      <div className="ticker" style={{zIndex: 10}}>
        <div className="ticker__track">
          <div className="ticker__group">
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
          </div>

          <div className="ticker__group" aria-hidden="true">
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
          </div>

          <div className="ticker__group" aria-hidden="true">
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">BUILT BEYOND BANKS</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">THE LENDING MARKET FOR EVERYBODY</span>
            <span className="ticker__sep">•</span>
            <span className="ticker__item">COMMONWEALTH</span>
            <span className="ticker__sep">•</span>
          </div>
        </div>
      </div>

      <div className="footer-grid" style={{zIndex: 10}}>
        <div className="footer-statement" style={{zIndex: 10}}>
          <h2 style={{zIndex: 10}}>
            Banking <br /> is dead.
          </h2>
          <p style={{zIndex: 10}}>
            Commonwealth is building financial infrastructure
            <br />
            for the next century. We&apos;re rethinking how capital moves, settles,
            and compounds, starting from first principles.
          </p>
        </div>

        <nav className="footer-nav" style={{zIndex: 10}}>
          <Link to="/home">Homepage</Link>
          <Link to="/manifesto">Mission</Link>
          <Link to="/needaj*b">Careers</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className={`footer-waitlist waitlist ${submitted ? "success" : ""}`} style={{zIndex: 10}}>
          <h2 style={{zIndex: 10}}>Join the waitlist</h2>
          <h3 style={{zIndex: 10}}>Break up with your bank.</h3>

          {!submitted && (
            <>
              <div className="waitlist-toggle">
                <button
                  className={combo === "emailOnly" ? "active" : ""}
                  onClick={() => setCombo("emailOnly")}
                  type="button"
                >
                  Email
                </button>
                <button
                  className={combo === "phoneOnly" ? "active" : ""}
                  onClick={() => setCombo("phoneOnly")}
                  type="button"
                >
                  Phone
                </button>
                <button
                  className={combo === "combined" ? "active" : ""}
                  onClick={() => setCombo("combined")}
                  type="button"
                >
                  Both
                </button>
              </div>

              <form onSubmit={postMongo}>
                {combo === "emailOnly" && (
                  <div className="waitlist-input">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Email address"
                      required
                    />
                    <button type="submit">→</button>
                  </div>
                )}

                {combo === "phoneOnly" && (
                  <div className="waitlist-input waitlist-input--phone">
                    <PhoneInput
                      country={"us"}
                      value={phone}
                      onChange={setPhone}
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoComplete: "tel",
                      }}
                      containerClass="phone2-container"
                      inputClass="phone2-input"
                      buttonClass="phone2-flag"
                      dropdownClass="phone2-dropdown"
                      placeholder="Phone number"
                      disableSearch
                      dropdownStyle={{
                        maxHeight: "150px",
                        overflowY: "auto",
                      }}
                    />
                    <button type="submit">→</button>
                  </div>
                )}

                {combo === "combined" && (
                  <>
                    <div className="waitlist-input">
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        placeholder="Email address"
                        required
                      />
                      <button type="submit">→</button>
                    </div>

                    <div
                      className="waitlist-input waitlist-input--phone"
                      style={{ marginTop: 6 }}
                    >
                      <PhoneInput
                        country={"us"}
                        value={phone}
                        onChange={setPhone}
                        inputProps={{
                          name: "phone",
                          required: true,
                          autoComplete: "tel",
                        }}
                        containerClass="phone2-container"
                        inputClass="phone2-input"
                        buttonClass="phone2-flag"
                        dropdownClass="phone2-dropdown"
                        placeholder="Phone number"
                        disableSearch
                        dropdownStyle={{
                          maxHeight: "90px",
                          overflowY: "auto",
                        }}
                      />
                      <button type="submit">→</button>
                    </div>
                  </>
                )}
              </form>
            </>
          )}

          <div className="waitlist-referral">
            <span>Your referral link</span>
            <code>{shareLink}</code>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2026 Commonwealth</span>

        <div className="footer-links">
          <Link to="/contact">Email</Link>
          <a href="https://x.com/trycommonwealth" target="_blank" rel="noreferrer">
            X
          </a>
          <a
            href="https://www.linkedin.com/company/commonwealthxyz"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </div>
  </footer>
  );
}
}
